import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Categories.css';
import CategoryCard from './CategoryCard';
import ProductImage from './ProductImage';

const Categories = ({ products }) => {
  const [activeCategory, setActiveCategory] = useState(null);

  // Получаем первое изображение товара из категории для изображения категории
  const getCategoryImage = (productList) => {
    if (productList && productList.length > 0) {
      const firstProductWithImage = productList.find(p => p.image);
      return firstProductWithImage?.image || null;
    }
    return null;
  };

  const categories = [
    {
      id: 'chaser',
      title: 'Жидкости Chaser',
      description: 'Chaser Black 6% - премиальные жидкости',
      products: products.chaser,
      color: '#667eea',
      image: getCategoryImage(products.chaser)
    },
    {
      id: 'elfliq',
      title: 'Жидкости ELFLIQ',
      description: 'ELFLIQ 5% 30ml - качество и вкус',
      products: products.elfliq,
      color: '#764ba2',
      image: getCategoryImage(products.elfliq)
    },
    {
      id: 'raya',
      title: 'Одноразки RAYA',
      description: 'RAYA D3 25000 - мощь и долговечность',
      products: products.raya,
      color: '#f093fb',
      image: getCategoryImage(products.raya)
    }
  ];

  return (
    <section className="categories">
      <div className="categories-container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Наши категории
        </motion.h2>
        
        <div className="categories-grid">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <CategoryCard
                category={category}
                isActive={activeCategory === category.id}
                onClick={() => setActiveCategory(
                  activeCategory === category.id ? null : category.id
                )}
              />
            </motion.div>
          ))}
        </div>

        <AnimatePresence>
          {activeCategory && (
            <motion.div
              className="products-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setActiveCategory(null)}
            >
              <motion.div
                className="products-modal"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                <button 
                  className="close-button"
                  onClick={() => setActiveCategory(null)}
                >
                  ×
                </button>
                <h3 className="modal-title">
                  {categories.find(c => c.id === activeCategory)?.title}
                </h3>
                <div className="products-list">
                  {categories.find(c => c.id === activeCategory)?.products.map((product, idx) => (
                    <motion.div
                      key={product.id}
                      className="product-item"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: idx * 0.05 }}
                    >
                      {product.image && (
                        <div className="product-image-wrapper">
                          <ProductImage
                            src={product.image}
                            alt={product.name}
                            category={categories.find(c => c.id === activeCategory)?.id}
                            productName={product.name}
                            className="product-image"
                          />
                        </div>
                      )}
                      <div className="product-info">
                        <span className="product-name">{product.name}</span>
                        {product.stock && (
                          <span className="product-stock">В наличии: {product.stock}</span>
                        )}
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Categories;

